<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Vessels &nbsp;
          <add-button link="/system-setup/vessels/create"></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">System Setup</li>
          <li class="breadcrumb-item">Vessels</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportvessels.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="vessels_excel"
                    :fields="excel_fields"
                    worksheet="Vessels"
                    name="Vessel.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel Name</th>
                    <th>Vessel Type</th>
                    <th>DWT</th>
                    <th>Code</th>
                    <th>Type Code</th>
                    <th>Build Year</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="vessels.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr v-for="(vessel, at) in vessels" :key="`vessel${at}`">
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ vessel.vessel_name }}</td>
                    <td>
                      {{ vessel.vessel_type }}
                    </td>
                    <td>
                      {{ vessel.dwt }}
                    </td>
                    <td>{{ vessel.code }}</td>
                    <td>{{ vessel.type_code }}</td>
                    <td>{{ vessel.build_year }}</td>

                    <td>
                      <div>
                        <router-link
                          :to="`/system-setup/vessels/${vessel.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(vessel.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "vessel",
  data() {
    return {
      vessels: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      vessels_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Vessel Name": "vessel_name",
        "Vessel Type": "vessel_type",
        DWT: "dwt",
        Code: "code",
        "Type Code": "type_code",
        "Build Year": "build_year",
        "SW Summer Draft": "sw_summer_draft",
        Ownership: "ownership",
      },
      Exportvessels: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let vessels = await axios.get(
        `/vessels?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.vessels = vessels.data.data;
      this.count = vessels.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let vessels = await axios.get(`/vessels?search=${this.searchData}`);
      this.vessels = vessels.data.data;
      this.count = vessels.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Vessel Data";
      this.vessels_excel = [];
      let Exportvessels = [];
      Exportvessels = await axios.get(`/vessels`);
      this.Exportvessels = Exportvessels.data.data;
      let sr_no = 1;
      this.Exportvessels.forEach((vessel) => {
        this.vessels_excel.push({
          sr_no: sr_no,
          vessel_name: vessel.vessel_name ? vessel.vessel_name : "",
          vessel_type: vessel.vessel_type ? vessel.vessel_type : "",
          dwt: vessel.dwt ? vessel.dwt.name : "",
          code: vessel.code ? vessel.code.name : "",
          type_code: vessel.type_code ? vessel.type_code : "",
          build_year: vessel.build_year ? vessel.build_year : "",
          sw_summer_draft: vessel.sw_summer_draft ? vessel.sw_summer_draft : "",
          ownership: vessel.ownership ? vessel.ownership : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=vessels`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
